import type { FC, RefObject } from 'react';
import { useMemo } from 'react';
import clsx from 'clsx';

import Tooltip from '@trend-dev/trendtech-ui/components/UI/Tooltip';

import type { IUser } from 'store/declare';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { currentUserLabel, participantLabel } from '../const';
import Icons from '../Icons';
import styles from './styles.module.scss';

interface Props extends Pick<IUser, 'type' | 'isMuted' | 'isSharing' | 'name' | 'position'> {
    /** Ссылка на обертку карточки пользователя. Используется для позиционирования тултипа */
    cardRef: RefObject<HTMLDivElement>;
    /** Пользователь является текущим пользователем */
    isCurrentUser: boolean;
}

const UserData: FC<Props> = ({ cardRef, isCurrentUser, isMuted, isSharing, name, position, type }) => {
    const { isDesktop } = useDeviceWidth();
    const isManager = type === 'manager';
    const renderIcons = useMemo(() => <Icons isMicEnabled={!isMuted} isSharing={isSharing} />, [isMuted, isSharing]);

    if (isDesktop) {
        const tooltipContent = (
            <div className={styles.tooltipContent}>
                <span className={styles.tooltipName}>{name}</span>
                <span>{isManager ? position : participantLabel}</span>
            </div>
        );

        return (
            <Tooltip
                className={styles.tooltip}
                kind='black'
                title={tooltipContent}
                arrow={false}
                maxWidth={230}
                position='bottom'
                customAuthor={cardRef}
            >
                <div className={clsx(styles.userData)}>
                    {renderIcons}
                    <span className={styles.userDataName}>{name}</span>
                    {isCurrentUser && <span className={styles.currentUser}> ({currentUserLabel})</span>}
                </div>
            </Tooltip>
        );
    }

    return renderIcons;
};

export default UserData;
